import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { PopupModal } from '@/components/common/Modal'
import * as dateutil from '@/util/date-helper'
@Component({
    components: {
        PopupModal,
    }
})
export default class RecurringDayModal extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Boolean, default: false }) show!: boolean
    @Prop({ type: Object }) value!: calendar.CalendarItem;

    WeekCheckboxArray: Array<any> = [{ flag: false, value: 0, text: '' }];

    created() {
        this.WeekCheckboxArray = dateutil.uGetWeekArray([
            this.$t('W_Schedule_Sunday').toString(),
            this.$t('W_Schedule_Monday').toString(),
            this.$t('W_Schedule_Tuesday').toString(),
            this.$t('W_Schedule_Wednesday').toString(),
            this.$t('W_Schedule_Thursday').toString(),
            this.$t('W_Schedule_Friday').toString(),
            this.$t('W_Schedule_Saturday').toString(),
        ]).map((x) => {
            let obj = Object.create(null);
            //obj.flag = this.isWeekChecked(x.value);
            obj.value = x.value;
            obj.text = x.text;
            return obj;
        });
    }

    check() {
        let checkedArray = this.WeekCheckboxArray.filter((x) => x.flag).map((x) => x.value)
        this.$emit('check', checkedArray)
    }
}
